var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCopy = function SvgCopy(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_13444_75307)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.61279,
    y: 0.806641,
    width: 24,
    height: 24,
    rx: 6.45161,
    fill: "#2f5fed"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.61279,
    y: 0.806641,
    width: 24,
    height: 24,
    rx: 6.45161,
    fill: "url(#paint0_linear_13444_75307)",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.01602,
    y: 1.20987,
    width: 23.1935,
    height: 23.1935,
    rx: 6.04839,
    stroke: "url(#paint1_linear_13444_75307)",
    strokeOpacity: 0.12,
    strokeWidth: 0.806452
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9892 10.7905H12.9408C12.1984 10.7905 11.5967 11.3923 11.5967 12.1346V18.183C11.5967 18.9253 12.1984 19.5271 12.9408 19.5271H18.9892C19.7315 19.5271 20.3332 18.9253 20.3332 18.183V12.1346C20.3332 11.3923 19.7315 10.7905 18.9892 10.7905Z",
    fill: "#2f5fed",
    stroke: "white",
    strokeWidth: 1.6129,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.90871 14.8225H8.23666C7.88019 14.8225 7.53832 14.6809 7.28625 14.4288C7.03419 14.1768 6.89258 13.8349 6.89258 13.4784V7.43002C6.89258 7.07355 7.03419 6.73168 7.28625 6.47961C7.53832 6.22755 7.88019 6.08594 8.23666 6.08594H14.2851C14.6415 6.08594 14.9834 6.22755 15.2355 6.47961C15.4875 6.73168 15.6291 7.07355 15.6291 7.43002V8.10207",
    stroke: "white",
    strokeWidth: 1.6129,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_13444_75307",
    x: -0.000110269,
    y: 0.000189006,
    width: 27.2258,
    height: 27.2258,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.806452,
    operator: "dilate",
    "in": "SourceAlpha",
    result: "effect1_dropShadow_13444_75307"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.310476 0 0 0 0 0.28 0 0 0 0 0.92 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13444_75307"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.806452
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.806452
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101823 0 0 0 0 0.0752604 0 0 0 0 0.633073 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_13444_75307",
    result: "effect2_dropShadow_13444_75307"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_13444_75307",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13444_75307",
    x1: 13.6128,
    y1: 0.806641,
    x2: 13.6128,
    y2: 24.8066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13444_75307",
    x1: 13.6128,
    y1: 0.806641,
    x2: 13.6128,
    y2: 24.8066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCopy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "copy.fe1b56787a6a027fdec084ca85d85715.svg";